
// vue
import { defineComponent } from 'vue';

export default defineComponent({
    props: ['courseSchema', 'saveCallback', 'closeCallback'],
    setup(props: any) {
        return {
            props,
        };
    },
});
